module.exports = __webpack_public_path__ + "media/images/flags/1x1/mng-db5576ddd164fed2bdd5caea606d9aeb.svg";